import { createIcon } from './create-icon'

export const Warning = createIcon({
  displayName: 'Warning',
  paths: [
    'M512 768c-23.595 0-42.667-19.072-42.667-42.667s19.072-42.667 42.667-42.667c23.595 0 42.667 19.072 42.667 42.667s-19.072 42.667-42.667 42.667zM554.667 554.667c0 23.595-19.072 42.667-42.667 42.667s-42.667-19.072-42.667-42.667v-128c0-23.595 19.072-42.667 42.667-42.667s42.667 19.072 42.667 42.667v128zM840.832 708.907l-269.995-501.504c-26.368-48.981-91.307-48.981-117.675 0l-269.995 501.504c-33.877 62.891 5.077 144.427 68.949 144.427h519.765c63.872 0 102.827-81.536 68.949-144.427z'
  ]
})
